import external from '@xero/xui-icon/icons/external';
import XUIButton from '@xero/xui/react/button';
import XUIIcon from '@xero/xui/react/icon';
import { FC } from 'react';
import AdminSVG from '../../assets/svgs/AdminSVG';
import ShoppingBasketSVG from '../../assets/svgs/ShoppingBasketSVG';
import lang from '../../static/lang/en-NZ';

export interface ISalesLayoutProps {
    isAdmin: boolean;
    onUpgradeClick: () => void;
}

const SalesLayout: FC<ISalesLayoutProps> = (props) => (
    <>
        <div className='xui-u-flex xui-u-flex-justify-center'>
            {props.isAdmin ? <ShoppingBasketSVG /> : <AdminSVG />}
        </div>
        <div className='access-upgrade-blurb xui-text-align-center'>
            <div data-automationid='sales-title' className='xui-heading-small xui-margin-vertical'>
                {props.isAdmin ? lang.SALES_LAYOUT.UPGRADE_TITLE : lang.SALES_LAYOUT.ADMIN_TITLE}
            </div>
            <div className='xui-textcolor-muted xui-margin-bottom-2xlarge'>
                {props.isAdmin ? lang.SALES_LAYOUT.UPGRADE_BLURB : lang.SALES_LAYOUT.ADMIN_BLURB}
            </div>
        </div>
        <div className='xui-u-flex xui-u-flex-justify-center xui-u-flex-align-center'>
            {props.isAdmin ? (
                <>
                    <XUIButton
                        className='xui-padding-horizontal-3xlarge xui-margin-right'
                        onClick={props.onUpgradeClick}
                    >
                        {lang.BUTTONS.UPGRADE_SUBSCRIPTION}
                    </XUIButton>
                    <a target='_blank' href='https://xero.com/pricing'>
                        {lang.BUTTONS.XERO_PRICING} <XUIIcon icon={external} className='external-link-icon' />
                    </a>
                </>
            ) : null}
        </div>
    </>
);

export default SalesLayout;
